import type { FaqItem } from '../components/ds';

export const SCRIPT_FAQ: readonly FaqItem[] = [
  {
    q: 'What script formats can I upload?',
    a: 'Final Draft (.fdx), PDF, Fountain, and direct paste. Slug lines, parentheticals, dual-dialogue, and action blocks parse natively, and production annotations like shot numbers and camera notes are kept and used.',
  },
  {
    q: 'Does it keep characters consistent across scenes?',
    a: 'Yes. The breakdown builds a Project Memory Graph — a persistent record of every character, wardrobe detail, location, and prop. Every shot generates from it and is verified against it, so your protagonist looks the same in every scene, whatever order shots are generated in.',
  },
  {
    q: 'Can I edit individual shots after generation?',
    a: 'Yes. Override any shot — angle, lens, lighting, pacing, performance — locally, with no global re-roll that breaks the surrounding cut. Each override is re-verified before it lands.',
  },
  {
    q: 'How long does it take?',
    a: 'A full-script breakdown takes under three minutes. Upload to a refinable, verified first cut is an afternoon, not weeks.',
  },
];
